import React, { useEffect, useState } from "react";

//Import Breadcrumb
import { Dialog, DialogContent, DialogTitle, Divider, FormHelperText, Grid, IconButton, Stack } from "@mui/material";
import { connect } from 'react-redux';
import { Card, CardBody } from "reactstrap";
import "../../Orders/order.css";
import CustomButton from "../../../components/Form/CustomButton";
import AppAttachmentDialog from "../../../components/Common/AppAttachmentDialog";

const Attachments = ({ setFormValues, values, error }) => {
    console.log("values in attachments", values?.pdf)
    const [openPdfModal, setOpenPdfModal] = useState(false);

    useEffect(() => {
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleOpenPdfModal = () => {
        if (!values?.pdf) return;
        setOpenPdfModal(true);
    };

    const handleClosePdfModal = () => {
        setOpenPdfModal(false);
    };

    const handleDeleteFiles = () => {
        setFormValues((prevValues) => ({
            ...prevValues,
            pdf: "",
            pdf_name: "",
            pdf_id: "",
        }))
    }

    const handleAddAttachments = (accept = "application/pdf", multiple = false) => {
        const input = document.createElement("input");
        input.type = "file";
        input.accept = accept;
        if (multiple) {
            input.multiple = true;
        }

        input.onchange = (e) => {
            const files = e.target.files;
            if (!files || files.length === 0) return;

            const file = files[0];
            if (file?.type !== "application/pdf") {
                handleDeleteFiles();
                return;
            }

            const reader = new FileReader();
            reader.onload = () => {
                setFormValues((prevValues) => ({
                    ...prevValues,
                    pdf: reader.result,
                    pdf_name: file?.name || "",
                    pdf_id: "",
                }))
            };

            reader.onerror = () => {
                handleDeleteFiles();
            };

            reader.readAsDataURL(file);
        };

        input.click();
    };

    const handleOpenPdfInNewTab = () => {
        if (values?.pdf) {
            if (values.pdf.startsWith("data:application/pdf;base64,")) {
                const byteCharacters = atob(values.pdf.split(",")[1]);
                const byteNumbers = new Array(byteCharacters.length).fill().map((_, i) => byteCharacters.charCodeAt(i));
                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], { type: "application/pdf" });
                const blobUrl = URL.createObjectURL(blob);
                window.open(blobUrl, '_blank');
            } else {
                window.open(values.pdf, '_blank');
            }
        }
    };

    return (
        <React.Fragment>
            {/* <AppAttachmentDialog
                open={openPdfModal}
                close={handleClosePdfModal}
                file={values?.pdf}
                filename={values?.pdf_name}
                filetype={"pdf"}
            /> */}
            <div className="">
                <Card className="p-3 px-2" style={{ minHeight: "40vh" }}>
                    <CardBody>
                        <Stack direction={"row"} justifyContent={"space-between"}>
                            <div className="setting-header">ATTACHMENTS</div>
                        </Stack>
                        <Divider className="my-2 mb-4" />
                        <div className="pb-3">Attachment</div>

                        <Grid container spacing={2} style={{ display: "flex", alignItems: "center" }}>

                            {values?.pdf ?

                                <Grid item xs={12}>
                                    <Card
                                        style={{ border: "#E3E8EE 1px solid" }}
                                        onClick={handleOpenPdfInNewTab}

                                    >
                                        <div className="p-3 d-flex align-items-center justify-content-between" style={{ cursor: "pointer" }}>
                                            <div>
                                                <i className="ri-file-text-line" style={{ fontSize: "18px" }}></i>
                                                <span style={{ marginLeft: "10px" }}>{values?.pdf_name}</span>
                                            </div>
                                            <span style={{ borderRadius: "5px", backgroundColor: "#44d62c", cursor: "pointer" }}>
                                                <i
                                                    style={{ color: "white" }}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        handleDeleteFiles();
                                                    }}
                                                    className="ri-delete-bin-6-line font-size-16 p-1"
                                                ></i>
                                            </span>

                                        </div>
                                    </Card>
                                </Grid> :
                                <>
                                    <Grid item auto>
                                        <div style={{ cursor: 'pointer', display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: "#FAFAFA", border: "#E3E8EE 1px solid", height: "54px", width: "54px", borderRadius: "5px" }}>
                                            <i className="ri-upload-2-line" style={{ color: '#D0D0D0', fontSize: 20 }} />
                                        </div>
                                    </Grid>
                                    <Grid item auto>
                                        <CustomButton
                                            title={'Choose'}
                                            press={() => handleAddAttachments("application/pdf", false)}
                                            backgroundColor={'#F2F2F2'}
                                            textColor={'#101010'}
                                            height={"33px"}
                                            borderStyle={'1px solid #E3E8EE'}
                                        />
                                        <FormHelperText style={{ fontFamily: 'Manrope-Bold' }}>PDF only. 10MB Max</FormHelperText>
                                        <FormHelperText sx={{ color: "red" }}>{error && error?.attachment}</FormHelperText>
                                    </Grid>
                                </>

                            }
                        </Grid>

                    </CardBody>
                </Card >
            </div >
        </React.Fragment >
    );
};

function mapStateToProps() {
    return {

    };
}


export default connect(mapStateToProps)(Attachments);
